import component from './PageVideo.vue'
export default component
